export const APP_CURRENCY = import.meta.env.VITE_APP_CURRENCY || 'AED';
